<template>
  <div class="key-ticket-pills" v-if="tickets && tickets.length">
    <span
      v-for="(ticket, index) in visibleTickets"
      :key="ticket.icon_key || ticket.name || index"
      class="ticket-pill"
      :class="`ticket-pill--${statusClass(ticket.status)}`"
      v-b-tooltip.hover="tooltip(ticket)"
    >
      <b-icon :icon="statusIcon(ticket.status)" class="ticket-pill__icon" />
      {{ ticket.name }}
    </span>
  </div>
</template>

<script>
// Renders up to 3 compliance-item pills on a CandidateCard (`key_tickets` in
// the search response — already compliance-status-ordered + capped at 3 by
// the API, this just guards against a longer array being passed anyway).
const STATUS_CLASS = {
  current: 'current',
  expiring_soon: 'expiring-soon',
  expired: 'expired',
  not_verified: 'not-verified',
  missing: 'missing',
}

const STATUS_ICON = {
  current: 'check-circle-fill',
  expiring_soon: 'exclamation-triangle-fill',
  expired: 'x-circle-fill',
  not_verified: 'x-circle-fill',
  missing: 'x-circle-fill',
}

export default {
  name: 'KeyTicketPills',

  props: {
    tickets: {
      type: Array,
      default: () => [],
    },
    max: {
      type: Number,
      default: 3,
    },
  },

  computed: {
    visibleTickets() {
      return (this.tickets || []).slice(0, this.max)
    },
  },

  methods: {
    statusClass(status) {
      return STATUS_CLASS[status] || 'current'
    },
    statusIcon(status) {
      return STATUS_ICON[status] || STATUS_ICON.current
    },
    tooltip(ticket) {
      if (!ticket) return { title: '', disabled: true }
      if (
        (ticket.status === 'expiring_soon' || ticket.status === 'expired') &&
        ticket.expiry_date
      ) {
        const label = ticket.status === 'expired' ? 'Expired' : 'Expiring soon'
        return { title: `${label}: ${ticket.expiry_date}`, disabled: false }
      }
      return { title: '', disabled: true }
    },
  },
}
</script>

<style lang="scss" scoped>
.key-ticket-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.ticket-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.25rem 0.55rem;
  border-radius: 999px;
  line-height: 1.1;
  white-space: nowrap;
}

// Matches the approval-status pill colours used elsewhere in the app (see
// CompanyApprovalBadge.vue / LabeledStatusBadge.vue) rather than the
// brighter raw-file valid/invalid palette.
.ticket-pill--current {
  background-color: #eaf6ee;
  color: #1f7a3a;
}

.ticket-pill--expiring-soon {
  background-color: #fdf6e3;
  color: #8a6a16;
}

.ticket-pill--expired,
.ticket-pill--not-verified,
.ticket-pill--missing {
  background-color: #fdecee;
  color: #a3242e;
}

.ticket-pill__icon {
  flex-shrink: 0;
  font-size: 0.85em;
}
</style>
